import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import DataActions from '../redux/dataRedux'
import { makeGetEventData } from '../selectors/eventDataSelector'
import { SENTINEL_KEY } from '../config/constants'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'
import formatDateToMonth from '../utility/formatDateToMonth'
import getBefore from '../utility/getBefore'

const datetimeToMosaicId = datetime => {
  if (!datetime) {
    return null
  }

  const date = new Date(datetime)
  const month = ('0' + date.getMonth()).slice(-2)
  const year = date.getFullYear()

  const mosaicId = `global_monthly_${year}_${month}_mosaic`

  return mosaicId
}

const MOSAIC_URL = ({ mosaicId='global_monthly_2018_09_mosaic' }) =>
      `https://tiles.planet.com/basemaps/v1/planet-tiles/${mosaicId}/gmap/{z}/{x}/{y}.png?api_key=c93217084d874198991837b45be28f49`
// https://tiles.planet.com/basemaps/v1/planet-tiles/global_monthly_18_06_mosaic/gmap/10/272/364.png?api_key=c93217084d874198991837b45be28f49

const ANALYSIS_URL = ({ idToken, timeIso }) =>
      `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3APipelineGreenEn2&width=512&height=512&srs=EPSG:3857&format=image%2Fpng8&transparent=true&TIME=${encodeURIComponent(
    timeIso
  )}/P1M&BBOX={bbox-epsg-3857}&token=${idToken}`


const id = 'PipelineMonthly'
const authId = 'Pipeline'
const datetimeId = 'PlanetMosaic'

const layout = {
  'line-cap': 'round'
}

export class Sentinel2Raster extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, hovered } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props

    const visible = layerRendered

    const mosaicId = datetimeToMosaicId(time)
    const before = 'default'
    const month = formatDateToMonth(new Date(time))
    const timeIso = month


    const mosaicSource = {
      type: 'raster',
      tiles: [MOSAIC_URL({ mosaicId })],
      tileSize: 512
    }
    const analysisSource = {
      type: 'raster',
      tiles: [ANALYSIS_URL({ idToken, timeIso })],
      tileSize: 512
    }

    if (!visible || !mosaicId) {
      return null
    }

    return (
      <div>
        <Source
          id={id+'Mosaic'}
          tileJsonSource={mosaicSource}
          />,
      <Layer
        type='raster'
        id={id+'Mosaic'}
        sourceId={id+'Mosaic'}
        before={before}
        />
      <Source
      id={id}
      tileJsonSource={analysisSource}
        />,
        <Layer
      type='raster'
      id={id}
      sourceId={id}
      paint={paint}
      before={getBefore(this.context, ['EnbridgePipeline'])}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getEventData = makeGetEventData()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, id),
      time: state.layer.times[datetimeId] || undefined,
      datetime: getDatetime(state, id) || '',
      hovered: getEventData(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event))
    }
  }
}

export default connect(makeMapStateToProps(), mapDispatchToProps)(Sentinel2Raster)



// WEBPACK FOOTER //
// ./src/layers/PipelineMonthly.js